export default "__VITE_ASSET__oN4d6Xmz__"